/**
 * File Selector Import
 * @description Dependencies: `yarn add primjs react-simple-code-editor`
 */
import Flatpickr from "react-flatpickr";

export default function DateInput(props) {
  return <Flatpickr className="form-control flatpickr-input" {...props} />;
}
